<template>
  <div class="header">
    <div class="container">
      <!--<h1 class="logo">
        <a href="/" class="logo-title"><i class="bicon-logo"></i></a>
      </h1>-->
      <div class="logo-subtitle">查询系统</div>
    </div>
  </div>
</template>
<script>

  export default {
    name: 'header',
    data () {
      return {

      }
    },
    methods : {

    }
  }
</script>



// WEBPACK FOOTER //
// header.vue?4670a556